<template>
  <div @click="toggleSwitch" class="toggleOuter" v-bind:class="{ toggleSwitching: switching, toggleDisabled: disabled, toggleOn: active}">
    <div class="toggleInner"></div>
  </div>
</template>

<script>

export default {
  name: 'ToggleSwitch',
  props: {
    active: Boolean,
    disabled: Boolean
  },
  data: function(){
    return {
      switching: false
    }
  },
  methods: {
    toggleSwitch(){
      if(!this.switching && !this.disabled) {
        this.switching = true;
        if (this.active) {
          this.$emit('toggleOff');
        } else {
          this.$emit('toggleOn');
        }
      }
    },
  },
  watch: {
    active: function() {
      if(this.switching) {
        this.switching = false;
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.toggleOuter {
  width: 52px;
  height: 26px;
  position: relative;
  border-radius: 26px;
  transition: 1s ease;
  &.toggleDisabled {
    cursor: not-allowed;
  }
  &:not(.toggleDisabled) {
    cursor: pointer;
  }
  &:not(.toggleOn) {
    border: 2px solid #5C5F6B;
    .toggleInner {
      background-color: #5C5F6B;

    }
  }
  &.toggleOn {
    border: 2px solid #6A7CE9;
    .toggleInner {
      background-color: #6A7CE9;
      transform: translateX(26px);
    }
  }
  &.toggleSwitching .toggleInner {
    animation: pulse 1.5s infinite;
  }
  .toggleInner {
    left: 3px;
    transition: 1s ease;
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 22px;
    top: 3px;
  }
}

@keyframes pulse {
    0% {
      opacity: .5;
    }

    50% {
      opacity: .1;
    }

    100% {
      opacity: .5;
    }
}
</style>
